<template>
  <div>
    新增轮播图
    <div class="input-wrap">
    	<label >输入序号 <span class="small-text">( 序号越小越靠前 )</span></label>
    	<el-input type="number" v-model="info.sort" placeholder="请输入排序序号" class="sort_input"></el-input>
    </div>
    <div class="img-wrap">
    	<label>上传图片 <span class="small-text">( 尺寸：375*150 )</span></label>
    	<imageUpload v-model="carousel_img" :limit="1"/>
    </div>
    <div class="btn-wrap">
			<el-button type="primary" class="confirmBtn" @click="confirmClick">保存</el-button>
			<el-button @click="cancelClick">取消</el-button>
		</div>
  </div>
</template>

<script>
import imageUpload from '@/components/ImageUpload';
import { addCarousel, carouselDetail, editCarousel } from '@/api/content-manage';

export default {
  name: 'messagepush',
  data() {
    return {
    	info: {
    		sort: '',
    		carousel_img: '',
    	},
    	carousel_img: [],
    	type: 'add',
    }
  },
  components: {
  	imageUpload,
  },
  mounted() {
  	let uuid = this.$route.query.uuid;
  	if (uuid) {
       this.getCarouselDetail(uuid);
       this.type = 'edit';
  	}
  },
  methods: {
  	async confirmClick() {
     if (!this.info.sort) {
     	this.$message('排序序号不能为空');
     	return
     }
     if (!this.carousel_img.length) {
     	this.$message('请上传图片');
     	return
     }
     this.info.carousel_img = this.carousel_img.join();
     if (this.type === 'add') {
        const { status } = await addCarousel(this.info);
        if (status === 200) this.$router.go(-1);
      } else if (this.type === 'edit') {
        const { status } = await editCarousel(this.info)
        if (status === 200) this.$router.go(-1);
      }
  	},
  	cancelClick() {
  		this.$router.go(-1);
  	},
  	async getCarouselDetail(uuid) {
      const { status, data } = await carouselDetail(uuid);
      if (status !== 200) return
      this.info = data;
      this.carousel_img = [data.carousel_img];
      console.log( data, 'detail')
  	}
  }
}
</script>

<style lang="less" scoped>
.input-wrap {
	margin-top: 30px;
	.sort_input {
		width: 300px;
  }
}
.small-text {
  font-size: 14px;
  color: #999;
}
label {
	display: block;
	margin-bottom: 10px;
}
.img-wrap {
	margin-top: 30px;
}
.btn-wrap {
	text-align: center;
	padding-top: 30px;
	padding-bottom: 30px;
	.confirmBtn {
		margin-right: 50px;
	}
}
</style>
